const DOCUMENT = 'TALENTS_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  BULK_FORM_REQUEST_REQUEST: DOCUMENT + 'BULK_FORM_REQUEST',
  BULK_FORM_REQUEST_SUCCESS: DOCUMENT + 'BULK_FORM_REQUEST_SUCCESS',
  CLOSE_BULK_REQUEST_MODAL: DOCUMENT + 'CLOSE_BULK_REQUEST_MODAL',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  bulkFormRequest: data => ({
    type: actions.BULK_FORM_REQUEST_REQUEST,
    payload: data,
  }),

  bulkRequestSuccess: () => ({
    type: actions.BULK_FORM_REQUEST_SUCCESS,
  }),

  closeBulkRequestModal: () => ({
    type: actions.CLOSE_BULK_REQUEST_MODAL,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
